import { Record, Map } from "immutable"

const ConfigurationHistory = Record({
  id: 0,
  configuration: Map(),
  previous_history: Map()
})

export default ConfigurationHistory
